import { replaceSpacesWithUnderscores } from '@util-lib/spacesToUnderscores'

export const createDataQaTag = (str: string): string =>
    replaceSpacesWithUnderscores(str.toLocaleLowerCase())
